import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AsynchronousProgressService {

  // goal: Guarda la cantidad de procesos asincronos que se realizarán
  goal = 0;
  // result: guarda la suma del cumplimiento de cada procesos asincronos
  result = 0;
  // emitter: Sujeto para compartir información
  emitter: Subject<boolean> = new Subject<boolean>();

  /* addResult() Método que suma el resultado de los procesos asincronos dando tiempo de espera para que se visualice el contador en la barra de carga
    value: Número a sumar al resultado
    time: Tiempo de espera para la suma
  */
  addResult(value: number, time: number = 15) {
    // ↓ Verifica que el valor a sumar sea mayor a 0
    if (value > 0) {
      setTimeout(() => {
        // increase: Valor a aumentar al porcentaje
        let increase: number = ((Math.floor(this.goal / 400) - Math.floor(this.result / 400)) + 1);
        // ↓ Verifica que no se sobrepase nunca el valor máximo a sumar
        if (value - increase < 0) { increase = value; }
        // ↓ Aumenta el cumplimiento del proceso
        this.result += increase;
        // ↓ Comparte los cambios
        this.emitter.next(this.result < this.goal);
        // ↓ Se llama a si mismo para que el proceso de aumento sea de 1 + increase
        this.addResult(value - increase, Math.ceil((Math.random() * 16) - 1));
      }, time);
    }
  }

  // resetValues(): Método que reinicia el cumplimiento y los procesos cada vez que se completa la carga
  resetValues() { [this.goal, this.result] = [0, 0]; }

}
